import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.vim = bracketIndenting({
	line: '"',
})
